import { render } from "./AdministratorMenu.vue?vue&type=template&id=24c803bc&ts=true"
import script from "./AdministratorMenu.vue?vue&type=script&lang=ts&setup=true"
export * from "./AdministratorMenu.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "/builds/easy/webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Components/Navigation/AdministratorMenu.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "24c803bc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('24c803bc', __exports__)) {
    console.log('reload')
    api.reload('24c803bc', __exports__)
  }
  
  module.hot.accept("./AdministratorMenu.vue?vue&type=template&id=24c803bc&ts=true", () => {
    console.log('re-render')
    api.rerender('24c803bc', render)
  })

}


export default __exports__